import { Calendar, Megaphone } from "lucide-react";

const statusColors = {
  pending: "bg-amber-50 text-amber-700",
  approved: "bg-emerald-50 text-emerald-700",
  rejected: "bg-red-50 text-red-700",
};

const activityLabels = {
  volunteer: "Volunteering",
  training: "Training",
  community_service: "Community Service",
  mentoring: "Mentoring",
  other: "Other",
};

export const OverviewTab = ({ dashboard, announcements }) => (
  <div className="space-y-6">
    {announcements.length > 0 && (
      <div className="space-y-3" data-testid="user-announcements">
        {announcements.map(a => (
          <div key={a.id} className={`rounded-xl p-4 border ${
            a.priority === "urgent" ? "bg-red-50 border-red-200" :
            a.priority === "important" ? "bg-amber-50 border-amber-200" :
            "bg-warm-50 border-warm-200"
          }`}>
            <div className="flex items-start gap-3">
              <Megaphone className={`w-5 h-5 mt-0.5 flex-shrink-0 ${
                a.priority === "urgent" ? "text-red-600" :
                a.priority === "important" ? "text-amber-600" :
                "text-warm-600"
              }`} />
              <div className="flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                  <h4 className="font-semibold text-gray-900 text-sm">{a.title}</h4>
                  {a.pinned && <span className="text-xs px-1.5 py-0.5 rounded bg-white/60 text-gray-600 font-medium">Pinned</span>}
                  {a.priority !== "normal" && (
                    <span className={`text-xs px-1.5 py-0.5 rounded font-medium ${
                      a.priority === "urgent" ? "bg-red-100 text-red-700" : "bg-amber-100 text-amber-700"
                    }`}>{a.priority}</span>
                  )}
                </div>
                <p className="text-sm text-gray-700 mt-1 whitespace-pre-line">{a.content}</p>
                <p className="text-xs text-gray-500 mt-2">{new Date(a.created_at).toLocaleDateString()}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    )}

    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      <div className="bg-white rounded-xl p-5 border border-gray-100" data-testid="overview-total-hours">
        <p className="text-sm text-gray-500">Approved Hours</p>
        <p className="text-3xl font-bold text-warm-700 mt-1">{dashboard.total_approved_hours}</p>
      </div>
      <div className="bg-white rounded-xl p-5 border border-gray-100" data-testid="overview-pending-hours">
        <p className="text-sm text-gray-500">Pending Reviews</p>
        <p className="text-3xl font-bold text-amber-600 mt-1">{dashboard.pending_hours_count}</p>
      </div>
      <div className="bg-white rounded-xl p-5 border border-gray-100" data-testid="overview-events">
        <p className="text-sm text-gray-500">Upcoming Events</p>
        <p className="text-3xl font-bold text-gray-900 mt-1">{dashboard.upcoming_events?.length || 0}</p>
      </div>
    </div>

    {dashboard.recent_hour_logs?.length > 0 && (
      <div className="bg-white rounded-xl border border-gray-100 p-5">
        <h3 className="font-semibold text-gray-900 mb-4">Recent Activity</h3>
        <div className="space-y-3">
          {dashboard.recent_hour_logs.map(log => (
            <div key={log.id} className="flex items-center justify-between py-2 border-b border-gray-50 last:border-0">
              <div>
                <p className="text-sm font-medium text-gray-900">{activityLabels[log.activity_type] || log.activity_type}</p>
                <p className="text-xs text-gray-500">{log.date} - {log.hours}h</p>
              </div>
              <span className={`text-xs px-2.5 py-1 rounded-full font-medium ${statusColors[log.status]}`}>
                {log.status}
              </span>
            </div>
          ))}
        </div>
      </div>
    )}

    {dashboard.upcoming_events?.length > 0 && (
      <div className="bg-white rounded-xl border border-gray-100 p-5">
        <h3 className="font-semibold text-gray-900 mb-4">Upcoming Events</h3>
        <div className="space-y-3">
          {dashboard.upcoming_events.map(evt => (
            <div key={evt.id} className="flex items-start gap-3 py-2 border-b border-gray-50 last:border-0">
              <Calendar className="w-5 h-5 text-warm-600 mt-0.5 flex-shrink-0" />
              <div>
                <p className="text-sm font-medium text-gray-900">{evt.title}</p>
                <p className="text-xs text-gray-500">{evt.start_date}{evt.start_time ? ` at ${evt.start_time}` : ""} {evt.location ? `- ${evt.location}` : ""}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    )}
  </div>
);
